/*
 * @Description: 秒杀多店门店列表
 * @Author: kayvor
 * @Date: 2020-04-01 18:28:16
 * @LastEditTime: 2020-06-03 11:54:46
 * @LastEditors: kayvor
 */

import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import {
    // getAllStoreList,
    getNearbySstores
} from '@/models/storeList'
import infiniteLoadData from '@/components/infiniteLoadData/infiniteLoadData.vue'

export default {
    name: viewName.seckillStoreList,
    components: {
        infiniteLoadData,
    },
    data () {
        return {
            nearbySstoresList: [],
            page: 1,
            pagesize: 20,
            isload: true
        }
    },
    computed: {
        ...mapState({

        }),
    },
    created () {

    },
    activated () {

    },
    mounted () {
        this.$emit('setHeader', {
            title: '选择门店',
            showHeader: true,
            showLeft: true
        })
        this.setAppClass({
            isAppend: false,
            className: 'bgGreyColor'
        })
    },
    methods: {
        ...mapActions([
            'getNearbySstores',
            'setAppClass'
        ]),
        // 获取门店-分页
        getPageList () {
            const { activity_id, spec_id, latitude, longitude } = this.$route.query
            let param = {
                activity_id,
                spec_id,
                latitude,
                longitude,
                type: 1,
                page: this.page,
                pagesize: this.pagesize
            }
            getNearbySstores(param).then(res => {
                const { list } = res
                this.nearbySstoresList = this.nearbySstoresList.concat(list)
                if (list.length < this.pagesize) {
                    this.isload = false
                    this.page = 1
                } else {
                    this.isload = true
                    this.page++
                }
            }).catch(_ => {
                this.isload = false
            })
        },
        /**
         * 上拉加载数据，在这里进行操作
         */
        scrollToEnd (scroll) {
            this.isload && this.getPageList()
        },
        /**
         * 监听是否初始化成功
         */
        init (scroll) {
            this.scroll = scroll
            this.getPageList()
        },
        /**
         * 跳转单店秒杀
        */
        goSeckill (sstore_id) {
            this.$router.push({
                path: '/seckill',
                query: {
                    sstore_id,
                    activity_id: this.$route.query.activity_id
                }
            })
        }
    },
    destroyed () {

    },
}
